import {
  List, Datagrid, TextField, EditButton, Edit, Create, SimpleForm,
  TextInput, NumberInput, required,
} from 'react-admin';
import { Stack } from '@mui/material';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { ImageUploadInput } from '../../components/ImageUploadInput.jsx';

const AlumniList = () => (
  <List sort={{ field: 'sortOrder', order: 'ASC' }} perPage={25}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="name" />
      <TextField source="classOf" label="Class of" />
      <TextField source="currentPath" label="Current path" />
      <EditButton />
    </Datagrid>
  </List>
);

const AlumniForm = () => (
  <Stack spacing={2} sx={{ maxWidth: 720 }}>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextInput source="name" validate={required()} fullWidth />
      <TextInput source="classOf" label="Class of (year)" sx={{ width: 160 }} />
    </Stack>
    <ImageUploadInput source="photo" label="Photo" />
    <TextInput source="currentPath" label="Current path / role" fullWidth helperText="e.g. Reading Medicine at King's College London" />
    <TextInput source="quote" multiline minRows={3} fullWidth />
    <NumberInput source="sortOrder" defaultValue={0} />
  </Stack>
);

const AlumniEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm><AlumniForm /></SimpleForm>
  </Edit>
);
const AlumniCreate = () => (
  <Create redirect="list">
    <SimpleForm><AlumniForm /></SimpleForm>
  </Create>
);

export default {
  list: AlumniList,
  edit: AlumniEdit,
  create: AlumniCreate,
  icon: PeopleAltIcon,
  options: { label: 'Alumni' },
  recordRepresentation: 'name',
};
